import api from './api';

const delWish = async function delWish(lectureId) {
  try {
    const response = await api.delete(`/api/lectures/${lectureId}/wish`);
    // CommonRestResponse 응답 처리
    if (response.data.success === 'D') {
      return {
        success: true,
        message: response.data.message || '위시리스트에서 삭제되었습니다.',
        wishStatus: (response.data.data && response.data.data.wishStatus) || 'N',
      };
    }
    throw new Error('서버 응답 오류');
  } catch (error) {
    console.error('위시리스트 삭제 오류:', error);
    const errorObj = new Error('위시리스트 삭제에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    errorObj.success = false;
    errorObj.originalError = error;
    throw errorObj;
  }
};

const addWish = async function addWish(lectureId) {
  try {
    const response = await api.post(`/api/lectures/${lectureId}/wish`);
    // CommonRestResponse 응답 처리
    if (response.data.success === 'C') {
      return {
        success: true,
        message: response.data.message || '위시리스트에 추가되었습니다.',
        wishStatus: (response.data.data && response.data.data.wishStatus) || 'Y',
      };
    }
    throw new Error('서버 응답 오류');
  } catch (error) {
    console.error('위시리스트 추가 오류:', error);
    const errorObj = new Error('위시리스트 추가에 실패했습니다. 잠시 후 다시 시도해 주세요.');
    errorObj.success = false;
    errorObj.originalError = error;
    throw errorObj;
  }
};

export { delWish, addWish };



// WEBPACK FOOTER //
// ./src/api/wishEdu.js